/*
 *     Import
 *     - Libraries
 */
import * as React from 'react'

class TextareaClaim extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            description: props.description,
        }
    }

    /**
     * Change the value of the description in the component state
     * and in the values from the parent
     *
     * @param {string} description
     * @memberof TextareaClaim
     */
    changeDescriptionValue = (description: string) => {
        this.props.setFieldValue(description, 'intendClaimsDescription')
        this.setState({ description })
    }

    /**
     * On focus set Label element with class 'active'
     */
    focusChange = (event: any) => {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    componentDidUpdate(prevProps: any) {
        const {
            description = '',
        } = this.props
        if (description && description !== prevProps.description) {
            this.setState({
                description: description,
            })
        }
    }

    render() {
        return (
            <div className={`quote__form__inner ${(this.props.show) ? 'active' : ''}`}>
                <div className="quote__form__group form__w100">
                    <textarea
                        name="intendClaimsDescription"
                        id="intendClaimsDescription"
                        placeholder="Enter your description..."
                        value={this.state.description}
                        onChange={(event) => { this.changeDescriptionValue(event.target.value) }}
                        onFocus={this.props.focusChange}
                    />
                </div>
            </div>
        )
    }
}

export default TextareaClaim



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step01/components/TextareaClaim.tsx